import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { userApi } from './external/api/user';
import { PaymentServiceType, SubscriptionsPayment } from './external/config/plans';


@Injectable()
export class PaymentService {
    private _intent: SubscriptionsPayment = null;
    constructor(private router: Router) {

    }
   
    public get intent() { return this._intent; }

    public getPaymentMethods = () => userApi.getPaymentMethods(this._intent);

    public createInvoice = (i: PaymentServiceType) => {
        this._intent.svc = i;
        return userApi.createInvoice(this._intent);
    }

    public startPayment(plan: SubscriptionsPayment) {
        this._intent = { ...plan };
        this.router.navigateByUrl('/user/payboard');
    }
}
